import type { GameplayMode } from '@systems/Options'
import type { DifficultyProfileId } from './difficultyProfiles'

export type MovementMode = GameplayMode

export type MovementTuning = {
  maxSpeed: number
  acceleration: number
  deceleration: number
  drag: number
  stopSpeed: number
}

export type DashTuning = {
  speed: number
  durationMs: number
  perfectBonusMultiplier: number
  iframeMs: number
}

export type PlayerHitboxTuning = {
  radius: number
}

export type PlayerMovementConfig = {
  movement: Record<MovementMode, MovementTuning>
  dash: DashTuning
  hitbox: Record<DifficultyProfileId | 'default', PlayerHitboxTuning>
}

export const playerMovementConfig: PlayerMovementConfig = {
  movement: {
    vertical: {
      maxSpeed: 640,
      acceleration: 3200,
      deceleration: 3800,
      drag: 7,
      stopSpeed: 16
    },
    omni: {
      maxSpeed: 720,
      acceleration: 3600,
      deceleration: 4200,
      drag: 6,
      stopSpeed: 18
    }
  },
  dash: {
    speed: 1200,
    durationMs: 320,
    perfectBonusMultiplier: 1.45,
    iframeMs: 220
  },
  hitbox: {
    easy: { radius: 12 },
    normal: { radius: 14 },
    hard: { radius: 15 },
    wip: { radius: 12 },
    default: { radius: 14 }
  }
}

export function getMovementTuning(mode: MovementMode): MovementTuning {
  return playerMovementConfig.movement[mode] ?? playerMovementConfig.movement.vertical
}

export function getDashTuning(): DashTuning {
  return playerMovementConfig.dash
}

export function getHitboxTuning(difficultyId: DifficultyProfileId | null | undefined): PlayerHitboxTuning {
  if (!difficultyId) return playerMovementConfig.hitbox.default
  return playerMovementConfig.hitbox[difficultyId] ?? playerMovementConfig.hitbox.default
}
